import { Icon, IconCertified } from "materia"
import { useTranslation } from "react-i18next"
import { FiestaLink } from "utility-components"
import { ProductCardShell } from "../ProductCard"
import { Stars } from "../Stars"
import type { Data } from "./gql"

import s from "./ProductBundleCard.module.scss"

export const ProductBundleCard = ({ data }: { data: Data }) => {
  const { id, products, progress, title } = data
  const { t } = useTranslation()

  const countText = t("bundle.products", {
    count: products.pageInfo.totalItemCount,
  })

  const images = products.nodes.map((product) => product.image)
  const noScoreBundleBadge = !progress.starsCount && !progress.starsMax
  const isCheckmarkVisible = progress.certified && !noScoreBundleBadge

  const count = progress.starsCount
  const max = progress.starsMax

  return (
    <li>
      <ProductCardShell>
        <FiestaLink to={`/bundle/${id}`} className={s.bundle}>
          {isCheckmarkVisible && (
            <IconCertified size="large" className={s.bundle__certifiedIcon} />
          )}
          <div className={s.bundle__images}>
            {images.map((image, index) => (
              <img key={index} className={s.bundle__image} src={image} alt="" />
            ))}
          </div>
          <div className={s.bundle__container}>
            <div className={s.bundle__count}>{countText}</div>
            <div className={s.bundle__title}>{title}</div>
            <div className={s.bundle__bottom}>
              {noScoreBundleBadge ? (
                <span />
              ) : (
                <div className={s.bundle__badge}>
                  <Stars
                    count={1}
                    max={1}
                    size="extraSmall"
                    ariaLabel={`${count} of ${max}`}
                  />
                  {count}/{max}
                </div>
              )}

              <Icon icon="Chevron" className={s.bundle__chevron} />
            </div>
          </div>
        </FiestaLink>
      </ProductCardShell>
    </li>
  )
}
